
export enum DeleteRowStatus {
    ACTIVE = "ACTIVE",
    FEATURE_INACTIVE = "FEATURE_INACTIVE",
    SCENARIO_SELECTED = "SCENARIO_SELECTED"
}

export type DeleteRowStatusMessage = {[k in keyof typeof DeleteRowStatus]: string};
